import { makeAsyncActionCreators } from '../../helpers';
import { ChaptersActionTypes } from '../types';

const addCommentToChapter = makeAsyncActionCreators(
  ChaptersActionTypes.addCommentToChapter,
  ['chapterId', 'commentId', 'comment', 'chapterData'],
  ['chapterId', 'comment'],
  ['error'],
);

const addReplyToCommentInChapter = makeAsyncActionCreators(
  ChaptersActionTypes.addReplyToCommentInChapter,
  ['chapterId', 'commentId', 'reply'],
  ['chapterId', 'commentId', 'reply'],
  ['error'],
);

const updateReplyToCommentInChapter = makeAsyncActionCreators(
  ChaptersActionTypes.updateReplyToCommentInChapter,
  ['chapterId', 'commentId', 'replyId', 'replyText'],
  ['chapterId', 'commentId', 'reply'],
  ['error'],
);

// TODO: CONSIDER ABOUT INCLUDING CHAPTER ID INSIDE CHAPTER
const updateChapter = makeAsyncActionCreators(
  ChaptersActionTypes.updateChapter,
  ['chapterId', 'chapter'],
  ['chapter'],
  ['error'],
);

const updateCommentInChapter = makeAsyncActionCreators(
  ChaptersActionTypes.updateCommentInChapter,
  ['chapterId', 'commentId', 'commentText'],
  ['chapterId', 'comment'],
  ['error'],
);

const resolveCommentInChapter = makeAsyncActionCreators(
  ChaptersActionTypes.resolveCommentInChapter,
  ['chapterId', 'commentId', 'chapterData'],
  ['chapterId', 'comment'],
  ['error'],
);

const deleteCommentInChapter = makeAsyncActionCreators(
  ChaptersActionTypes.deleteCommentInChapter,
  ['chapterId', 'commentId', 'chapterData'],
  ['chapterId', 'comment'],
  ['error'],
);

const deleteOrUndoComments = makeAsyncActionCreators(
  ChaptersActionTypes.deleteOrUndoComments,
  ['chapterId', 'deltaCommentsIds', 'chapterData'],
  ['chapterId', 'comments'],
  ['error'],
);

const saveChaptersChanges = makeAsyncActionCreators(
  ChaptersActionTypes.saveChaptersChanges,
  ['chapters', 'chaptersToDelete', 'dedication', 'bookTitleIdeas', 'redirection', 'navigate', 'callback', 'bookId'],
  ['chapters', 'book'],
  ['error'],
);

const fetchProofDataByProjectId = makeAsyncActionCreators(
  ChaptersActionTypes.fetchProofDataByProjectId,
  ['projectId', 'commentId'],
  ['chapters', 'project', 'book'],
  ['error'],
);

const fetchProofDataByUserId = makeAsyncActionCreators(
  ChaptersActionTypes.fetchProofDataByUserId,
  ['userId', 'commentId'],
  ['chapters', 'project', 'book'],
  ['error'],
);

export default {
  addCommentToChapter,
  addReplyToCommentInChapter,
  updateReplyToCommentInChapter,
  updateChapter,
  updateCommentInChapter,
  resolveCommentInChapter,
  deleteCommentInChapter,
  deleteOrUndoComments,
  saveChaptersChanges,
  fetchProofDataByProjectId,
  fetchProofDataByUserId,
};
